import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  get,
  // find,
  isEqual,
  toNumber,
} from 'lodash';
import withRouter from '../../../wrappers/withRouter';
import {
  tablePropsType,
  tablePropsDefault,
} from '../../../types/tablePropsType';
import {
  getSettings,
  getFiltersFromUrl,
  getData,
} from '../../../helpers/Table';
import {
  getParam,
} from '../../../helpers/Navigation';
import {
  format as formatCurrency,
} from '../../../utils/CurrencyUtil';
// import API from '../../../api';
import VibeTable from '../VibeTable';
import VibeModal from '../../VibeModal/VibeModal';
import VibeAlert from '../../VibeAlert/VibeAlert';
import VibeButton from '../../VibeButton/VibeButton';
import VibeIcon from '../../VibeIcon/VibeIcon';
import viDownload from '../../../icons/viDownload';
import CellTooltip from '../CellTypes/CellTooltip';
import * as color from '../../../sass/color.scss';

const tableId = 'table:allocations';
const permissionPrefix = 'flight';

class TableAllocations extends PureComponent {
  constructor(props) {
    super(props);

    const {
      // columns: columnNames,
      orderType,
      dataType,
      dataSource,
      defaultSortBy,
      pageSize,
      paginatorProps: {
        urlPaging,
        urlFilters,
      },
    } = props;

    const columnNames = this.getColumnsFromDataSource(dataType, dataSource, orderType);

    const columnsDef = [{
      name: '.',
      defaultWidth: 40,
    },
    {
      name: 'Name',
      searchAttr: 'name',
      defaultWidth: 275,
      resizable: true,
      searchable: true,
      sortable: true,
      autoFocus: true,
    },
    {
      name: 'Target Impressions',
      searchAttr: 'targetImpressions',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Total Impressions',
      searchAttr: 'totalImpressions',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Total Spots',
      searchAttr: 'totalSpots',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Delivered Impressions',
      searchAttr: 'deliveredImpressions',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Delivered Spots',
      searchAttr: 'deliveredSpots',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Frequency',
      searchAttr: 'frequency',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'CPM',
      searchAttr: 'cpm',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Impression Media Value Delivered',
      searchAttr: 'mediaCost',
      defaultWidth: 250,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Budget',
      searchAttr: 'budget',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
    },
    {
      name: 'Salesforce ID',
      searchAttr: 'salesforceId',
      defaultWidth: 175,
      resizable: true,
      sortable: true,
      searchable: true,
    },
    {
      name: '...',
      defaultWidth: 72,
    }];

    const settings = getSettings({
      tableId,
      columnsDef,
      columnNames,
    });

    this.state = {
      columnsDef,
      columnNames,
      rows: [],
      loading: true,
      totalItems: 0,
      active: !urlFilters || (urlFilters && getParam('active') !== 'false'),
      pageNumber: urlPaging
        ? parseInt(getParam('page') || 1, 10)
        : 1,
      pageSize: get(settings, 'pageSize', pageSize),
      sortBy: {
        label: get(settings, 'sortBy.label', defaultSortBy.label),
        attr: get(settings, 'sortBy.attr', defaultSortBy.attr),
        direction: get(settings, 'sortBy.direction', defaultSortBy.direction),
      },
      filters: urlFilters
        ? getFiltersFromUrl({ columns: columnsDef })
        : {},
      confirm: false,
      confirmRow: {},
      confirmAction: '',
      confirmTitle: '',
      confirmText: '',
      confirmApproveColor: '',
    };

    // listen for when datasource changes
    document.addEventListener('onUpdateAllocation', this.onUpdateTableData);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const {
      fetch,
      collection,
      // columns,
      dataType,
      dataSource,
      orderType,
    } = this.props;

    const {
      collection: prevCollection,
      // columns: prevColumns,
      dataSource: prevDataSource,
    } = prevProps;

    if (!fetch && !isEqual(collection, prevCollection)) {
      this.onUpdate({
        refresh: true,
      });
    }

    // allow updating of columns based on filters
    if (!isEqual(dataSource, prevDataSource)) {
      this.setState({
        columnNames: this.getColumnsFromDataSource(dataType, dataSource, orderType),
      }, () => {
        document.dispatchEvent(new Event('onRenderTable'));
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('onUpdateAllocation', this.onUpdateTableData);
  }

  /**
   * When an event asks the table to update the table data
   */
  onUpdateTableData = () => {
    this.onUpdate({
      refresh: true,
    });
  };

  // onSelectMenuItem = (itemName, _rowId) => {
  //   const {
  //     rows,
  //   } = this.state;

  //   const row = find(rows, { _rowId });

  //   if (!row) {
  //     console.error('Row not found matching ID', _rowId);
  //     return;
  //   }

  //   switch (itemName) {
  //     case 'archive': {
  //       this.setState({
  //         confirm: true,
  //         confirmAction: itemName,
  //         confirmRow: row,
  //         confirmTitle: 'Archive Company',
  //         confirmText: `Are you sure you want to archive ${row.name}?`,
  //         confirmApproveColor: 'error',
  //       });

  //       break;
  //     }

  //     case 'unarchive': {
  //       this.setState({
  //         confirm: true,
  //         confirmAction: itemName,
  //         confirmRow: row,
  //         confirmTitle: 'Unarchive Company',
  //         confirmText: `Are you sure you want to unarchive ${row.name}?`,
  //         confirmApproveColor: 'warning',
  //       });

  //       break;
  //     }

  //     default:
  //       break;
  //   }
  // };

  // onConfirmModal = async () => {
  //   const {
  //     collection,
  //     onRemove,
  //   } = this.props;

  //   const {
  //     confirmAction,
  //     confirmRow: {
  //       _id,
  //     },
  //   } = this.state;

  //   if (!_id) {
  //     console.error('onConfirmModal no row ID');
  //     return;
  //   }

  //   switch (confirmAction) {
  //     case 'archive': {
  //       const response = await API.Company.deactivate(_id);

  //       const successText = 'COMPANY.DEACTIVATED';
  //       const success = get(response, '[0].type') === successText;

  //       if (success) {
  //         // if using a local collection, remove from the table
  //         if (collection.length > 0) {
  //           const items = collection.filter(item => item._id === _id);

  //           items.forEach((item) => {
  //             // remove the item from the table
  //             onRemove(item);
  //           });
  //         }

  //         // tell listening components to update the counts and table data
  //         this.onUpdate({
  //           refresh: true,
  //         });
  //       }

  //       break;
  //     }

  //     case 'unarchive': {
  //       const response = await API.Company.reactivate({
  //         _id,
  //       });

  //       const successText = 'COMPANY.REACTIVATED';
  //       const success = get(response, '[0].type') === successText;

  //       if (success) {
  //         // tell listening components to update the counts and table data
  //         this.onUpdate({
  //           refresh: true,
  //         });
  //       }

  //       break;
  //     }

  //     default:
  //       break;
  //   }

  //   this.resetConfirmModal();
  // };

  /**
   * When the Bulk Archive Completes
   */
  onBulkArchive = () => {
    // tell listening components to update the counts and table data
    this.onUpdate({
      refresh: true,
    });
  };

  /**
   * Reset to Default Settings
   */
  onReset = () => {
    const {
      defaultSortBy,
      pageSize,
    } = this.props;

    this.onUpdate({
      refresh: true,
      data: {
        sortBy: defaultSortBy,
        pageSize: pageSize || 50,
      },
    });
  };

  onUpdate = ({
    data,
    refresh = false,
  }) => {
    if (refresh) {
      // refresh the table data
      this.setState(data, this.getData);
    } else {
      this.setState(data);
    }
  };

  onExport = () => {
    this.getData({
      export: true,
    });
  };

  getData = async (config = {}) => {
    const {
      props,
      state,
    } = this;

    if (!state.loading && !config.export) {
      this.setState({
        loading: true,
      });
    }

    const {
      rows,
      filters,
      totalItems,
    } = await getData({
      props,
      state,
      config,
    });

    if (rows) {
      this.setState({
        loading: false,
        rows,
        totalItems,
      });

      props.onFetchComplete({
        rows,
        filters,
        totalItems,
      });
    }
  };

  /**
   * Get Columns from Data Source Selected
   */
  getColumnsFromDataSource = (dataType, dataSource, orderType) => {
    switch (dataSource) {
      case 'banner': {
        if (dataType === 'flight' && orderType === 'always-on-pmp') {
          // Always On Flight
          return [
            'Name',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        } else if (dataType === 'flight') {
          // Flight
          return [
            'Name',
            'Target Budget',
            'Target Impressions',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            'Budget',
            '...',
          ];
        }

        if (orderType === 'always-on-pmp') {
          // Always On Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        }

        if (orderType === 'open-exchange') {
          // Open Exchange Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'Impression Media Value Delivered',
            '...',
          ];
        }

        // Order
        return [
          'Name',
          'Target Budget',
          'Target Impressions',
          'Total Impressions',
          'Total Spots',
          'Delivered Impressions',
          'Delivered Spots',
          'Frequency',
          'CPM',
          'Budget',
          '...',
        ];
      }

      case 'location': {
        if (dataType === 'flight' && orderType === 'always-on-pmp') {
          // Always On Flight
          return [
            'Name',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        } else if (dataType === 'flight') {
          // Flight
          return [
            'Name',
            'Target Budget',
            'Target Impressions',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            'Budget',
            '...',
          ];
        }

        if (orderType === 'always-on-pmp') {
          // Always On Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        }

        if (orderType === 'open-exchange') {
          // Open Exchange Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'Impression Media Value Delivered',
            '...',
          ];
        }

        // Order
        return [
          'Name',
          'Target Budget',
          'Target Impressions',
          'Total Impressions',
          'Total Spots',
          'Delivered Impressions',
          'Delivered Spots',
          'Frequency',
          'CPM',
          'Budget',
          '...',
        ];
      }

      case 'company':
      default: {
        if (dataType === 'flight' && orderType === 'always-on-pmp') {
          // Always On Flight
          return [
            'Name',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        } else if (dataType === 'flight') {
          // Flight
          return [
            'Name',
            'Target Impressions',
            'Total Impressions',
            'Total Spots',
            'Frequency',
            'CPM',
            'Budget',
            '...',
          ];
        }

        if (orderType === 'always-on-pmp') {
          // Always On Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'CPM',
            '...',
          ];
        }

        if (orderType === 'open-exchange') {
          // Open Exchange Order
          return [
            'Name',
            'Delivered Impressions',
            'Delivered Spots',
            'Frequency',
            'Impression Media Value Delivered',
            '...',
          ];
        }

        // Order
        return [
          'Name',
          'Target Impressions',
          'Total Impressions',
          'Total Spots',
          'Delivered Impressions',
          'Delivered Spots',
          'Frequency',
          'CPM',
          'Budget',
          '...',
        ];
      }
    }
  };

  /**
   * Reset the confirm modal data
   */
  resetConfirmModal = () => {
    this.setState({
      confirm: false,
    });
  };

  renderCell = ({
    column,
    row,
  }) => {
    const {
      currencyCode,
    } = this.props;

    // get the attribute with data for the cell
    const attr = column.valueAttr || column.searchAttr;
    const value = get(row, attr, '');

    switch (column.name) {
      case 'Name': {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {row?.warnings?.length > 0 && (
              <VibeAlert
                style={{
                  marginRight: 8,
                  fontSize: 12,
                }}
                severity="warning"
                alerts={row.warnings || []}
                size={24}
                iconOnly
              />
            )}

            <CellTooltip title={value}>
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {value}
              </div>
            </CellTooltip>
          </div>
        );
      }

      case 'Budget':
      case 'Impression Media Value Delivered':
      case 'CPM': {
        const formatValue = formatCurrency(value, currencyCode);

        return (
          <CellTooltip title={formatValue}>
            <div className="cell-content">
              {formatValue}
            </div>
          </CellTooltip>
        );
      }

      case 'Target Impressions':
      case 'Total Impressions':
      case 'Total Spots':
      case 'Delivered Impressions':
      case 'Delivered Spots':
      case 'Frequency': {
        const formatValue = toNumber(value).toLocaleString();

        return (
          <CellTooltip title={formatValue}>
            <div className="cell-content">
              {formatValue}
            </div>
          </CellTooltip>
        );
      }

      default:
        return (
          <CellTooltip title={value}>
            <div className="cell-content">
              {value}
            </div>
          </CellTooltip>
        );
    }
  };

  render() {
    const {
      className,
      toolbarProps,
      csv,
    } = this.props;

    const {
      columnsDef,
      columnNames,
      rows,
      loading,
      totalItems,
      active,
      pageNumber,
      pageSize,
      sortBy,
      filters,
      confirm,
      confirmTitle,
      confirmText,
      confirmApproveColor,
    } = this.state;

    const totalItemsStr = totalItems.toLocaleString();
    const customButtons = [];

    if (csv) {
      customButtons.push(
        <VibeButton
          key="btn-export"
          variant="outlined"
          text="Export"
          color="secondary"
          icon={(
            <VibeIcon
              icon={viDownload}
              color={color.primary}
              size={16}
            />
          )}
          tooltip={`Export ${totalItemsStr} Allocations to CSV`}
          tooltipProps={{
            placement: 'top',
          }}
          onClick={this.onExport}
        />,
      );
    }

    // add export button
    const newToolbarProps = {
      ...toolbarProps,
      customButtons: [
        ...get(toolbarProps, 'customButtons', []),
        ...customButtons,
      ],
    };

    return (
      <div className={classNames('Table', 'TableAllocations', className)}>
        <VibeTable
          {...this.props}
          toolbarProps={newToolbarProps}
          tableId={tableId}
          columnsDef={columnsDef}
          columnNames={columnNames}
          rows={rows}
          loading={loading}
          permissionPrefix={permissionPrefix}
          sortBy={sortBy}
          filters={filters}
          totalItems={totalItems}
          active={active}
          pageNumber={pageNumber}
          pageSize={pageSize}
          renderCell={this.renderCell}
          // bulkArchive={API.Company.deactivateBulk}
          // onSelectMenuItem={this.onSelectMenuItem}
          onBulkArchive={this.onBulkArchive}
          onReset={this.onReset}
          onUpdate={this.onUpdate}
        />

        <VibeModal
          show={confirm}
          type="confirm"
          confirmProps={{
            color: confirmApproveColor,
          }}
          title={confirmTitle}
          text={confirmText}
          // onConfirm={this.onConfirmModal}
          onClose={this.resetConfirmModal}
        />
      </div>
    );
  }
}

TableAllocations.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  ...tablePropsType,
};

TableAllocations.defaultProps = {
  ...tablePropsDefault,
};

export default withRouter(TableAllocations);
